import http from "@/core/global/http"
import type { IPatientReportResponse } from "@/modules/Patient/Overview/components/patientReportTables/patient-report.types"

export const getPatientReport = async (
  orgId: string,
  patientId: string,
): Promise<IPatientReportResponse> => {
  const { data } = await http.get(
    `/patient-mgmt/v3/org/${orgId}/patients/${patientId}/report`,
  )
  return data.result
}
